// extracted by mini-css-extract-plugin
module.exports = {"default-picture":"default-picture__b28_v"};